import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: HeaderBarTypes, Creators: HeaderBarActions } = createActions(
  {
    setHeaderTheme: ['theme'],
  },
  { prefix: 'HEADER_BAR_' }
);

export const INITIAL_STATE = Immutable({
  theme: null,
});

const handleHeaderThemeSet = (state, { theme }) => state.set('theme', theme);

export const reducer = createReducer(INITIAL_STATE, {
  [HeaderBarTypes.SET_HEADER_THEME]: handleHeaderThemeSet,
});
